import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
// import { borderRadius } from "@mui/system";
import "./ModalTerminos.css";
//import { textAlign } from "@mui/system";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "65%",
  height: "16em",
  // height: "70%",
  overflow: "auto",
  bgcolor: "background.paper",
  border: "1px solid #000",
  boxShadow: 22,
  p: 3,
  borderRadius: "8px",
};

export default function ModalTerminos({ openModal, setOpenModal }) {
  const handleClose = () => setOpenModal(false);
  return (
    <div>
      <Modal
        open={openModal}
        onClose={handleClose}
        // aria-labelledby="modal-modal-title"
        // aria-describedby="modal-modal-description" modal_mst
      >
        <Box sx={style} className=" box_mst">
          <Typography
            // id="modal-modal-title"
            className="text-center font-bold title_mst title2_mst"
            variant="h7"
            component="h2"
          >
            CONDICIONES DE USO
          </Typography>
          <Typography
            id="modal-modal-description"
            // align="justify"
            sx={{ fontSize: "14px" }}
            className="pt-4 text_mst text-justify"
            //sx={{ mt: 2 }}
          >
            Con su aceptación autoriza a la Universidad RICARDO PALMA (sito en
            Av. Benavides 5440, Santiago de Surco, Lima 33, Perú) a hacer uso de
            su correo electrónico y datos registrados en este sitio web, a fin
            de contactarlo y remitirle información sobre su interés; éste uso
            podrá ser realizado directamente por la Universidad o por un tercero
            autorizado por ésta, garantizando siempre la seguridad y
            confidencialidad de la información brindada.<br></br>
            <br></br>Su autorización para el uso de su correo electrónico es
            obligatorio, sin ella no podremos realizar nuestra actividad
            informativa.<br></br>
            <br></br>
            La autorización que otorgue es por tiempo indefinido; sin embargo,
            podrá revocarla o ejercer cualquiera de los derechos previstos en la
            Ley N.° 29733, Ley de Protección de Datos Personales, y su
            reglamento, de manera gratuita, enviando una comunicación a
            info@urp.edu.pe o a proteccion.dato@urp.edu.pe<br></br>
            <br></br>
            Una vez realizado el reclamo, se enviará un correo de confirmación a
            la dirección proporcionada en el formulario.
          </Typography>
        </Box>
      </Modal>
    </div>
  );
}
